import React from "react";

const IconClose = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={33}
      height={33}
      viewBox="0 0 33 33"
      fill="none"
      {...props}
    >
      <rect
        x="5.22656"
        y="26.4716"
        width="29.8572"
        height="2.29671"
        rx="1.14835"
        transform="rotate(-45 5.22656 26.4716)"
        fill="#EF7D00"
      />
      <rect
        width="29.8572"
        height="2.29671"
        rx="1.14835"
        transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 27.9648 26.4716)"
        fill="#EF7D00"
      />
    </svg>
  );
};

export default IconClose;
